const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
        
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);


  function addRecToCart(vid){
  
   
    event.preventDefault();

    console.log('vid', vid)
  
  
    let formData = {
     'items': [{
      'id': vid,
      'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      console.log('added rec to cart', response.json);
    
      const productRecommendationsSection = document.querySelector('.product-recommendations');
      const url = productRecommendationsSection.dataset.url;
      
      fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
    
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }

            cleanUpRecs();
            
          })
          .catch(e => {
            console.error(e);
          });
    
      
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
   
}

  function cleanUpRecs(){
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Do something with the cart data
        console.log(cart); 
        cart.items.forEach(function(item){
          const el = document.querySelector(`.product-recommendations__list-item[data-vid="${item.id}"]`);
          console.log('======el======', el);
      
          el.style.display = 'none'; 
        });
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }
